module.exports = __webpack_public_path__ + "static/media/userBG.0422e74d.jpg";